<template>
  <div class="NEW-loginPage">
    <input type="hidden" />
    <div class="register">
      <div class="register-left">
        <div class="login_information">
          <div class="image" @click="goLogin()">
            <img
              src="../../assets/img/logo9.svg"
              title="返回登录"
              style="width: 317px; height: 60px"
            />
          </div>

          <div class="marginBottom16">
            <div class="flex">
              <p class="contact_txt">{{ $getText("find_Account_problem") }}</p>
            </div>

            <div class="flex">
              <p class="contact_phone"></p>
              <span class="contact_txt_span">{{ $getText("leftPhone1") }}</span>
              <p class="contact_email"></p>
              <span class="contact_txt_span">NewMedia@cmaph.org</span>
            </div>
          </div>
          <div class="marginBottom16">
            <div class="flex">
              <p class="contact_txt">
                {{ $getText("find_collecting_and_editing") }}
              </p>
            </div>
            <div class="flex">
              <p class="contact_phone"></p>
              <span class="contact_txt_span">{{ $getText("leftPhone2") }}</span>
              <p class="contact_email"></p>
              <span class="contact_txt_span">NewMedia@cmaph.org</span>
            </div>
          </div>
          <div class="marginBottom16">
            <div class="flex">
              <p class="contact_txt">
                {{ $getText("find_full_text_database") }}
              </p>
            </div>
            <div class="flex">
              <p class="contact_phone"></p>
              <span class="contact_txt_span">{{ $getText("leftPhone3") }}</span>
              <p class="contact_email"></p>
              <span class="contact_txt_span">info@cmaph.org</span>
            </div>
          </div>

          <div class="main_other">
            <h1 class="header">{{ $getText("find_over_login") }}</h1>
            <div class="login-icon">
              <span
                class="qq"
                v-for="(item, i) in loginList"
                :key="i"
                @click="next(item)"
                :class="item.providerId + '-icon'"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="register-form">
        <!-- 找回密码 !retrieveState_true-->
        <div
          v-show="!retrieveState_true"
          class="retrieve_form"
          style="margin-top: -2px"
        >
          <p class="headers-getPass">
            <span class="divF"></span>
            <span v-show="retrieve_phone"
              >{{ $getText("find_Retrieve_password_via_phone") }}
            </span>
            <span v-show="!retrieve_phone"
              >{{ $getText("find_Retrieve_password_via_Email") }}
            </span>
          </p>
          <el-form
            label-position="top"
            label-width="100px"
            :model="form"
            :rules="rules1"
            ref="form2"
            class="form"
          >
            <!-- 切换按钮 -->
            <div class="register-switch-button">
              <ul class="register-switch" @click="changeHandle()">
                <li :class="switchOn == 'zh' ? 'switch-btn' : ''">中</li>
                <li
                  class="switch-on"
                  :class="switchOn == 'en' ? 'switch-off' : ''"
                ></li>
                <li :class="switchOn == 'en' ? 'switch-btn' : ''">EN</li>
              </ul>
            </div>
            <!-- / PHONE NUMBER  手机号 -->
            <el-form-item
              :label="$getText('reg_phone')"
              prop="phone"
              v-show="retrieve_phone"
            >
              <el-input
                class="no-autofill-pwd"
                v-model.trim="form.phone"
                :placeholder="$getText('reg_phone_hint')"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <!-- / EMAIL 电子邮箱 -->
            <el-form-item
              :label="$getText('reg_email')"
              prop="email"
              v-show="!retrieve_phone"
            >
              <el-input
                class="no-autofill-pwd"
                v-model.trim="form.email"
                :placeholder="$getText('reg_email_hint1')"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <!-- VERIFICATION CODE  验证码-->
            <el-form-item :label="$getText('find_code')" prop="imageCode">
              <div style="display: flex">
                <el-input
                  class="imgInput no-autofill-pwd"
                  ref="codeInput"
                  v-model="form.imageCode"
                  autocomplete="off"
                  :placeholder="$getText('find_input_code')"
                ></el-input>
                <div class="imgCode" @click="getImagerCode">
                  <img :src="imageUrl" alt="" />
                </div>
              </div>
            </el-form-item>
            <!-- 手机验证码 -->
            <el-form-item
              :label="$getText('reg_phone_code')"
              prop="confirmationCode"
              v-show="retrieve_phone"
              class="phoneOREmail"
            >
              <el-input
                class="codeInput no-autofill-pwd"
                v-model="form.verifyCode"
                :placeholder="$getText('find_code_correct_phone')"
                autocomplete="off"
              ></el-input>
              <div
                class="telCode"
                @click="getTelCode_get"
                v-show="!timeDownSta"
                style="background: #d63630"
              >
                {{
                  getOneCode
                    ? retrieve_phone
                      ? $getText("reg_get_code")
                      : $getText("reg_get_code1")
                    : $getText("find_regain")
                }}
                <i
                  v-if="loding"
                  style="font-size: 12px"
                  class="el-icon-loading"
                ></i>
                <!-- 手机找回 -->
              </div>
              <div class="telCode grayCode" v-show="timeDownSta">
                {{ $getText("find_regain") }}({{ timeDowns }}s)
              </div>
              <!-- </div> -->
            </el-form-item>

            <!-- 邮箱验证码 -->
            <el-form-item
              class="phoneOREmail"
              :label="$getText('reg_email_code')"
              prop="confirmationCode"
              v-show="!retrieve_phone"
            >
              <el-input
                class="codeInput no-autofill-pwd"
                v-model="form.verifyCode"
                :placeholder="
                  this.retrieve_phone
                    ? $getText('reg_email_code_hint')
                    : $getText('reg_email_code_hint1')
                "
                autocomplete="off"
              ></el-input>
              <div
                class="telCode"
                @click="getTelCode_get"
                v-show="!timeDownSta"
                style="background: #d63630"
              >
                {{
                  getOneCode
                    ? retrieve_phone
                      ? $getText("reg_get_code")
                      : $getText("reg_get_code1")
                    : $getText("find_regain")
                }}
                <i
                  v-if="loding"
                  style="font-size: 12px"
                  class="el-icon-loading"
                ></i>
                <!-- 邮箱找回 -->
              </div>
              <div class="telCode grayCode" v-show="timeDownSta">
                {{ $getText("find_regain") }}({{ timeDowns }}s)
              </div>
            </el-form-item>
            <!-- 密码 / PASSWORD -->
            <el-form-item
              prop="Password"
              class="Password"
              :style="{ marginBottom: enHeight ? '40px' : '20px' }"
            >
              <div slot="label" class="Password-text">
                <span>{{ $getText("reg_password1") }}</span>
                <span class="spanTip">({{ passwordTipTextZh }})</span>
              </div>

              <el-input
                class="no-autofill-pwd"
                type="password"
                v-model="form.password"
                :placeholder="
                  this.retrieve_phone
                    ? $getText('reg_password_hint')
                    : $getText('reg_password_hint')
                "
                autocomplete="new-password"
              ></el-input>
            </el-form-item>
            <!-- 确认密码 / CONFIRM PASSWORD -->
            <el-form-item
              :label="$getText('find_CONFIRM_PASSWORD')"
              prop="confirmPassword"
            >
              <el-input
                class="no-autofill-pwd"
                type="password"
                v-model="form.confirmPassword"
                :placeholder="$getText('find_CONFIRM_PASSWORD_two1')"
                autocomplete="new-password"
              ></el-input>
            </el-form-item>
          </el-form>
          <p class="login-tips-text" v-show="getPasstit">{{ getPasstit }}</p>

          <el-button class="registerBtn" @click="getPassWord()">
            {{ $getText("find_RETRIEVE") }}</el-button
          >
          <p
            class="ForgetPass getPass"
            v-show="!retrieve_phone"
            @click="getPassQh"
          >
            <span>{{ $getText("find_pass_phone") }}</span>

            <span style="font-family: monospace">{{
              $getText("find_jiantou")
            }}</span>
          </p>
          <p
            class="ForgetPass getPass"
            v-show="retrieve_phone"
            @click="getPassQh"
          >
            <span> {{ $getText("find_pass_email") }}</span>

            <span style="font-family: monospace">{{
              $getText("find_jiantou")
            }}</span>
          </p>
          <div class="online" style="" @click="gotoUrl">
            <img src="../../assets/img/new-Login_icon-footer2.png" alt="" />
            <span>{{ $getText("find_Online") }}</span>
          </div>
        </div>
        <div
          class="retrieve_true"
          v-show="retrieveState_true"
          style="margin-top: -4px"
        >
          <headerTitle
            :title="$getText('find_Password_Rese')"
            style="padding: 0"
          />
          <!-- 切换按钮 -->
          <div class="register-switch-button">
            <ul class="register-switch" @click="changeHandle()">
              <li :class="switchOn == 'zh' ? 'switch-btn' : ''">中</li>
              <li
                class="switch-on"
                :class="switchOn == 'en' ? 'switch-off' : ''"
              ></li>
              <li :class="switchOn == 'en' ? 'switch-btn' : ''">EN</li>
            </ul>
          </div>
          <div class="retrieve_true_title">
            <img
              :src="regImageUrl"
              alt=""
              style="width: 64px; height: 64px; margin: 0 auto"
            />
            <div class="chinese">
              <p>{{ $getText("find_password_success") }}</p>
              <p>{{ $getText("find_password_success_reset") }}</p>
            </div>

            <el-button class="registerBtn1" @click="goLogin()">
              {{ $getText("find_LOFGIN_NOW") }}
              <!-- 马上登录 / LOFGIN NOW -->
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="register-bottom">
      <div style="padding: 25px 0 0 0">
        <p>
          <span>京ICP备</span>
          <span class="spanColor">07035254号-1</span>
          <span> 京公网安备</span>
          <span style="color: #666; padding: 0 8px">11010102000192号</span>
          <span> 出版物经营许可证</span>
          <span style="color: #666; padding: 0 10px 0 10px"
            >新出发京零字第东130025号</span
          >
        </p>
        <p class="h10"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Get, Post } from "@/api/axios";
import axios from "axios";
import headerTitle from "./headerTitle.vue";
export default {
  components: { headerTitle },
  name: "login",
  data() {
    let userName = (rule, value, callback) => {
      if (!this.form.userName) {
        callback(new Error(this.$getText("find_input_account")));
      }
    };
    let userPass = (rule, value, callback) => {
      if (!this.form.password) {
        callback(new Error(this.$getText("reg_password_hint")));
      }
    };
    let imageCode = (rule, value, callback) => {
      if (!this.form.imageCode) {
        callback(new Error(this.$getText("reg_code_hint")));
      }
    };
    let phone = (rule, value, callback) => {
      // 执行phone
      if (!this.form.phone || this.form.phone == "") {
        callback(new Error(this.$getText("reg_phone_hint")));
        return;
      }
      var flag = /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.phone);
      if (!flag) {
        callback(new Error(this.$getText("reg_phone_hint_two")));
        this.registerSta = false;
      } else {
        // 验证手机号
        let data = {
          mobileno: this.form.phone,
        };
        Get(
          "/member/spc/" +
            window.version +
            "/baas/member/checkMobileExist?mobile=" +
            this.form.phone
        ).then((res) => {
          let data = res.data;
          console.log(data.status, "data.status");
          if (data.status == 1) {
            if (this.retrieveState) {
              // 手机号已注册 可以找回密码
              this.registerSta = true;
              callback();
            } else {
              callback(
                new Error(
                  data.message ||
                    this.$getText("find_phone_Registered_mail_true")
                )
              );
              this.registerSta = false;
            }
          } else {
            if (this.retrieveState) {
              this.registerSta = false;
              callback(
                new Error(this.$getText("find_phone_Registered_mail_false"))
              );
            } else {
              callback(new Error(this.$getText("reg_phone_hint_four")));
              this.registerSta = true;
            }

            if (this.form.imageCode) {
              // 如果先输入了图片验证码
              // this.getImageCodeTrue(callback);
            }
          }
        });
      }
    };
    let image = (rule, value, callback) => {
      // 图片验证码
      if (!this.form.imageCode || !this.form.imageCode.replace(/\s/g, '')) {
        callback(new Error(this.$getText("find_input_code")));
      } else if (
        (this.registerSta || this.regEmailSta) &&
        this.form.imageCode
      ) {
        // this.getImageCodeTrue(callback);
      }
      // 找回密码
      else if (this.retrieveState && this.form.imageCode) {
        // this.getImageCodeTrue(callback)
      }
    };
    let Password = (rule, value, callback) => {
      this.enHeight = false;
      Get(
        "/member/spc/" + window.version + "/getConfig?key=PASSWORD_RULES"
      ).then((res) => {
        let data = res.data;
        //  console.log(data);
        if (res.data.length > 0) {
          let text = new RegExp(JSON.parse(data[0].value).passwordRules.value);
          // console.log(text);
          let flag = text.test(this.form.password);
          // console.log(flag);
          if (!this.form.password) {
            this.enHeight = false;
            callback(new Error(this.$getText("find_password_hint")));
          } else if (!flag) {
            if (this.switchOn == "zh") {
              this.enHeight = false;
              this.passwordTipTextZh = JSON.parse(
                data[0].value
              ).passwordRules1.value;
              callback(
                new Error(JSON.parse(data[0].value).passwordRules1.value)
              );
            } else {
              this.enHeight = true;
              this.passwordTipTextZh = JSON.parse(
                data[0].value
              ).passwordRules1.value;
              callback(
                new Error(JSON.parse(data[0].value).passwordRules2.value)
              );
            }
          }
        }
      });
      // let flag =
      //   /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,16}$/.test(
      //     this.form.password
      //   );
    };
    let confirmpassword = (rule, value, callback) => {
      if (!this.form.confirmPassword) {
        callback(new Error(this.$getText("reg_confirm_password_hint1")));
      } else if (this.form.password != this.form.confirmPassword) {
        callback(new Error(this.$getText("reg_confirm_password_hint_two")));
      } else {
        callback();
      }
    };
    let code = (rule, value, callback) => {
      if (!this.form.verifyCode) {
        callback(new Error(this.$getText("find_code_correct_hint")));
      }
    };
    let email = (rule, value, callback) => {
      if (!this.form.email || this.form.email == "") {
        callback(new Error(this.$getText("reg_email_hint")));
        return;
      }
      let flag =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/.test(
          this.form.email
        );
      if (!flag) {
        callback(new Error(this.$getText("reg_email_hint_two")));
        this.regEmailSta = false;
      } else {
        Get(
          "/member/spc/" +
            window.version +
            "/baas/member/checkEmailExist?email=" +
            this.form.email
        ).then((res) => {
          console.log(res.data.status,'res.data.status');
          if (res.data.status == 1) {
            console.log(this.retrieveState, "是否为找回密码页面");
            if (this.retrieveState) {
              this.regEmailSta = true;
              callback();
            } else {
              callback(
                new Error(this.$getText("find_email_Registered_mail_true"))
              );
              this.regEmailSta = false;
            }
          } else {
            if (this.retrieveState) {
              this.regEmailSta = false;
              callback(
                new Error(this.$getText("find_email_Registered_mail_false"))
              );
            } else {
              callback(new Error(this.$getText("find_email_authentication")));
              this.regEmailSta = true;
            }
            // if (this.form.imageCode) {
            //    如果先输入了图片验证码
            //    this.getImageCodeTrue(callback);
            // }
          }
        });
      }
    };
    let codeJc = (rule, value, callback) => {
      if (!this.form.phone || this.form.phone == "") {
        callback(new Error(this.$getText("reg_phone_hint")));
        return;
      }
      let flag = /^1[3-9]\d{9}$/.test(this.form.phone);
      if (!flag) {
        callback(new Error(this.$getText("reg_phone_hint_two")));
        this.registerSta = false;
      }
    };
    let emailJc = (rule, value, callback) => {
      if (!this.form.email || this.form.email == "") {
        callback(new Error(this.$getText("reg_email_hint")));
        return;
      }
      let flag =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/.test(
          this.form.email
        );
      if (!flag) {
        callback(new Error(this.$getText("reg_email_hint_two")));
        this.regEmailSta = false;
      }
    };

    return {
      passwordTipTextZh: "",
      passwordTipTextEn: "",
      enHeight: false,
      registerState: false, // 注册页面
      loginState: true, // 登录页面
      retrieveState: true, // 找回密码页面
      retrieveState_true: false,
      registerState_true: false,

      // 注册页面
      checked: true, // 用户须知 默认勾选
      emailState: false, // 注册方式 （默认手机号注册）
      getOneCode: true, // 页面第一次获取验证码
      timeDowns: 0, // 倒计时60s
      timeDownSta: false, // 验证码倒计时状态
      registerSta: true, // 手机号状态 可用
      refisterTit: "", // 注册提示

      // 登录页面
      automaticLogin: false, // 自动登录
      Tips: "", // 错误提示

      // 找回密码页面
      retrieve_phone: true, // 当前通过手机号找回密码  false 邮箱
      getPasstit: "", // 找回密码提示

      // 通用
      imageUrl: require("@/assets/img/new-Login_bg.jpg"), // 图片路径 首次默认
      regImageUrl: require("@/assets/img/modified-c_img.svg"), // 找回密码
      imageToken: "", // 图片token

      // 通用表单
      ip: "", // ip地址
      form: { password: "" },
      rules: {
        phoneNumber: [{ validator: phone, trigger: "blur" }],
        imageCode: [{ validator: image, trigger: "blur" }],
        confirmationCode: [{ validator: code, trigger: "blur" }],
        Password: [{ validator: Password, trigger: "blur" }],
        confirmPassword: [{ validator: confirmpassword, trigger: "blur" }],

        // 邮箱验证
        emailString: [{ validator: email, trigger: "blur" }],

        // 手机号邮箱基础验证
        phone: [{ validator: codeJc, trigger: "blur" }],
        email: [{ validator: emailJc, trigger: "blur" }],

        userName: [{ validator: userName, trigger: "blur" }],
        userPass: [{ validator: userPass, trigger: "blur" }],
        code: [{ validator: imageCode, trigger: "blur" }],
      },
      rules1: {
        // 手机号邮箱基础验证
        phone: [{ validator: phone, trigger: "blur" }],
        email: [{ validator: email, trigger: "blur" }],

        imageCode: [{ validator: image, trigger: "blur" }],
        confirmationCode: [{ validator: code, trigger: "blur" }],
        Password: [{ validator: Password, trigger: "blur" }],
        confirmPassword: [{ validator: confirmpassword, trigger: "blur" }],

        userName: [{ validator: userName, trigger: "blur" }],
        userPass: [{ validator: userPass, trigger: "blur" }],
        code: [{ validator: imageCode, trigger: "blur" }],
      },
      imageCodeSta: false,
      zcYzm: true,
      loginList: [],
      switchOn: "",
      fullscreenLoading: false,
      loding: "",
    };
  },
  beforeCreate() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--; )
        document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
    }
  },
  created() {
    this.getMember();
    this.$nextTick(() => {
      let id = sessionStorage.getItem("token");
      if (!id) {
        axios({
          url:
            "/baas-platform/" +
            window.version +
            "/platform/appauthtoken?appKey=6kLvKOGL1h8uICWE",
          method: "get",
        }).then((res) => {
          let token = res.data.data;
          sessionStorage.setItem("token", res.data.data);
          localStorage.setItem("time", new Date().getTime());
          // axios({
          //   url: "/member/spc/" + window.version + "/getPublishKey",
          //   method: "post",
          //   headers: {
          //     authToken: token,
          //   },
          // }).then((res) => {
          //   if (res.data.status == 0) {
          //     if (typeof res.data.data == "string") {
          //       localStorage.setItem("gy", res.data.data);
          //     }
          //   }
          // });
        });
      }
      let a = JSON.parse(window.localStorage.getItem("AutoContent"));
      if (a) {
        this.automaticLogin = true;
        this.toLogin(a);
        // 自动登录
      }
    });
  },
  mounted() {
    let _that = this;
    this.getUserIP((ip) => {
      this.ip = ip;
    });
    setTimeout(() => {
      this.getImagerCode();
    }, 333);
    if (
      localStorage.getItem("languageValue") &&
      localStorage.getItem("languageValue") != "undefined" &&
      localStorage.getItem("languageValue") != ""
    ) {
      this.switchOn = localStorage.getItem("languageValue");
      localStorage.setItem("languageValue", "zh");
    } else {
      this.switchOn = "zh";
    }
    // document.addEventListener("visibilitychange", function () {
    //   if (document.visibilityState == "hidden") {
    //     localStorage.setItem("languageValue", "zh");
    //     //切离该页面时执行
    //   } else if (document.visibilityState == "visible") {
    //     //切换到该页面时执行
    //     setTimeout(() => {
    //       localStorage.setItem("languageValue", _that.switchOn);
    //     }, 0);
    //   }
    // });

    this.getPassText();
    console.log(this.switchOn,'this.switchOn');
    if (this.switchOn == "zh") {
      $("title").html("找回密码 - 中华医学会杂志社统一身份认证系统");
    } else if (this.switchOn == "en") {
      $("title").html("Retrieve password - CMA Publishing House Network");
    } else {
      $("title").html("找回密码 - 中华医学会杂志社统一身份认证系统");
    }
    console.log(this.$casLoginUrl,'this.$casLoginUrl');
  },
  watch: {
    retrieveState(n) {
      if (!n) {
        // this.getOneCode = true
        this.getPassQh();
        // this.getImagerCode();
      }
    },
    switchOn(n, o) {
      // n 新的值 o 旧的值
      if (o === "") {
        this.fullscreenLoading = true;
      } else {
        this.fullscreenLoading = false;
      }
    },
  },
  methods: {
    // cleart() {
    //   var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    //   if (keys) {
    //     for (var i = keys.length; i--; )
    //       document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
    //   }
    // },
    gotoUrl() {
      // location.href='https://cmaph.soboten.com/chat/pc/v2/index.html?sysnum=b3bcde969fc34532baa0bdb60d88f276&channelid=2'
      window.open(
        "https://cmaph.soboten.com/chat/pc/v2/index.html?sysnum=b3bcde969fc34532baa0bdb60d88f276&channelid=2"
      );
    },
    getPassText() {
      console.log(this.switchOn, "this.switchOn");
      Get(
        "/member/spc/" + window.version + "/getConfig?key=PASSWORD_RULES"
      ).then((res) => {
        let data = res.data;
        //  console.log(data);
        if (res.data.length > 0) {
          if (this.switchOn == "zh") {
            this.passwordTipTextZh = JSON.parse(
              data[0].value
            ).passwordRules1.value;
          } else {
            this.passwordTipTextZh = JSON.parse(
              data[0].value
            ).passwordRules2.value;
          }
        }
      });
    },
    //   点击中英文按钮
    changeHandle() {
      // 切换
      this.refisterTit = "";
      this.form = {};
      this.zcYzm = true;
      // this.form.verifyCode = "";
      // this.form.password = "";
      // 验证码计时器重置
      this.timeDowns = 0;
      this.timeDownSta = false;
      this.getOneCode = true;

      // 清空表单验证
      this.$refs["form2"].resetFields();
      this.switchOn = this.switchOn == "zh" ? "en" : "zh";
      this.$changeLang();
      this.$bus.$emit("footerUpdate");
      if (this.switchOn == "zh") {
        $("title").html("找回密码 - 中华医学会杂志社统一身份认证系统");
      } else {
        $("title").html("Retrieve password - CMA Publishing House Network");
      }
      this.getPassText();
    },
    //   点击按钮
    next(item) {
      let params = {
        service: location.href + "&bindThLogin=" + item.providerId,
      };
      localStorage.setItem("loginProviderId", item.providerId);
      Get(
        "/member/spc/" + this.$version1 + "/third_login/" + item.providerId,
        params
      ).then((res) => {
        if (res.status == 0) {
          location.href = res.data;
        }
      });
    },
    getMember(e) {
      let params = {
        version: this.$version1,
      };
      Get("/member/spc/" + params.version + "/third_login_provider").then(
        (res) => {
          if (res.status == 0) {
            this.loginList = res.data.content;
          }
        }
      );
    },
    // 自动登录
    autoLogin(e) {
      if (!e) {
        window.localStorage.removeItem("AutoContent");
      }
    },
    // 去登录
    // goLogin() {
    //   let locals =
    //     window.location.protocol +
    //     "//" +
    //     window.location.host +
    //     "/personal?nowNav=basicInfo";
    //   let codes =
    //     window.location.protocol +
    //     "//" +
    //     window.location.host +
    //     "/member/cas/auth?redirectUrl=" +
    //     locals;
    //   location.href = this.$casLogin + "?service=" + codes;
    // },
     goLogin() {
      console.log(this.casLoginUrl,'casLoginUrl');
      window.location.href =
        localStorage.getItem("casLogin") +
        // "?service=https://ucenter.yiigle.com/member/cas/auth?redirectUrl=https://ucenter.yiigle.com/personal";
        `?service=${localStorage.getItem("clientIndexUrl")}/member/cas/auth?redirectUrl=${localStorage.getItem("clientIndexUrl")}/personal`
    },
    // 找回密码切换
    getPassQh() {
      this.retrieve_phone = !this.retrieve_phone;
      this.form = {};
      this.form2 = {};
      this.form1 = {};
      this.getPasstit = "";
      this.$refs["form2"].resetFields();
      this.getImagerCode();

      this.zcYzm = true;
      this.registerSta = false;
      this.timeDowns = 0;
      this.timeDownSta = false;
      this.getOneCode = true;
    },
    // 图片点击去登录页
    goHome() {
      this.Tips = "";
      this.refisterTit = "";
      this.getPasstit = "";
      this.form = {};
      this.form2 = {};
      this.form1 = {};
      this.loginState = true;
      this.registerState = false;
      this.retrieveState = false;
      this.getImagerCode();
      this.$refs["form"].resetFields();
      this.$refs["form1"].resetFields();
      this.$refs["form2"].resetFields();
      this.registerSta = false;

      this.zcYzm = true;
      this.timeDowns = 0;
      this.timeDownSta = false;
      this.getOneCode = true;
    },
    // 切换注册方式
    switchMode() {
      // 切换
      this.refisterTit = "";
      this.emailState = !this.emailState;
      this.form = {};
      this.zcYzm = true;
      // this.form.verifyCode = "";
      // this.form.password = "";
      // 验证码计时器重置
      this.timeDowns = 0;
      this.timeDownSta = false;
      this.getOneCode = true;

      // 清空表单验证
      this.$refs["form"].resetFields();
      // 重置图片验证码
      this.getImagerCode();
    },
    // 获取图片验证码
    getImagerCode() {
      Get("/member/spc/" + window.version + "/validateImage").then((res) => {
        if (res.status === 0) {
          this.imageUrl = "data:image/png;base64," + res.data.BASE64;
          this.imageToken = res.data.imageToken;
        }
      });
    },
    // 图片验证码验证
    getImageCodeTrue(callback) {
      let ar = false;
      let params = {
        imageToken: this.imageToken, // 图片Token 必
        imageCode: this.form.imageCode,
      };
      Get("/member/spc/" + window.version + "/checkValidateImage", {
        ...params,
      }).then((res) => {
        ar = true;
        if (res.status === 0) {
          if (res.data.state == "false") {
            this.imageCodeSta = false;
            if (callback) {
              callback(
                new Error(res.data.message || "请输入正确的图片验证码！")
              );
            } else {
              this.Tips = res.data.message || "请输入正确的图片验证码！";
            }
          } else {
            this.imageCodeSta = true;
          }
        } else {
          if (callback) {
            callback(new Error("请输入正确的图片验证码！"));
          } else {
            this.Tips = "请输入正确的图片验证码！";
          }
        }
      });
      return ar;
    },
    // 获取验证码 (注册)
    getTelCode() {
      if (
        !this.emailState && // 注册方式
        (!this.form.phone || // 手机号
          !this.registerSta) // 手机号状态
        // || !this.form.imageCode || // 图片验证码
        // !this.imageCodeSta   //*** 图片验证码只能验证第一次 // 图片验证码状态
      ) {
        // 手机注册form参数不全
        // this.$refs["form"].validate((valid) => {
        //   if (!valid) {
        //     return false;
        //   }
        // });
        return;
      } else if (
        this.emailState &&
        (!this.form.email || !this.regEmailSta)
        // || !this.imageCodeSta
      ) {
        // 邮箱form参数不全
        // this.$refs["form"].validate((valid) => {
        //   if (!valid) {
        //     return false;
        //   }
        // });
        return;
      }
      if (!this.form.imageCode || !this.form.imageCode.replace(/\s/g, '')) {
        this.$message({
          message: this.$getText("find_input_code"),
          type: "warning",
        });
        this.$refs.codeInput.focus();
        this.$refs.codeInput.blur();
        return
      }
      if (!this.zcYzm) {
        return false;
      }
      this.zcYzm = false;
      // 手机号验证码 注册
      if (!this.emailState) {
        Get(
          "/member/spc/" +
            window.version +
            "/sendMobileVerifyCode2?type=mobile_register&expiredTime=5&mobileno=" +
            this.form.phone + "&imageToken=" + this.imageToken + "&imageCode=" + this.form.imageCode
        ).then((res) => {
          if (res.status === 0) {
            this.timeDownSta = true;
            this.timeDowns = 60;
            this.getOneCode = false; // 第一次获取验证码
            if (this.timeDowns > 0) {
              let time = setInterval(() => {
                this.timeDowns--;
                if (this.timeDowns == 0) {
                  this.timeDownSta = false;
                  clearInterval(time);
                }
                if (this.timeDowns < 1) {
                  this.zcYzm = true;
                }
              }, 1000);
            }
          } else {
          }
        });
      }
      // 邮箱验证码
      else if (this.emailState) {
        // spc/v1/sendEmailVerifyCode?email=836269228@qq.com?type=email_register&expiredTime=10
        Get(
          "/member/spc/" +
            window.version +
            "/sendEmailVerifyCode2?type=email_register&expiredTime=5&email=" +
            this.form.email + "&imageToken=" + this.imageToken + "&imageCode=" + this.form.imageCode
        ).then((res) => {
          if (res.status === 0) {
            this.timeDownSta = true;
            this.timeDowns = 60;
            this.getOneCode = false; // 第一次获取验证码
            if (this.timeDowns > 0) {
              let time = setInterval(() => {
                this.timeDowns--;
                if (this.timeDowns == 0) {
                  this.timeDownSta = false;
                  clearInterval(time);
                }
              }, 1000);
            }
          } else {
          }
        });
      }
    },
    // 获取验证码 (找回)
    getTelCode_get() {
      console.log("点击验证码");
      console.log(this.form.phone, "手机号");
      console.log(this.registerSta, "是否为有效手机号");
      if (this.retrieve_phone && (!this.form.phone || !this.registerSta)) {
        this.$message({
          message: this.$getText("testAndVerify"),
          type: "warning",
        });

        // 找回手机form参数不全
        return;
      } else {
        if (!this.retrieve_phone && (!this.form.email || !this.regEmailSta)) {
          this.$message({
            message: this.$getText("testAndVerify1"),
            type: "warning",
          });
          return;
        }
      }
      if (!this.form.imageCode || !this.form.imageCode.replace(/\s/g, '')) {
        this.$message({
          message: this.$getText("find_input_code"),
          type: "warning",
        });
        this.$refs.codeInput.focus();
        this.$refs.codeInput.blur();
        return
      }
      this.loding = true;
      let url = "";
      if (!this.retrieve_phone) {
        url =
          "/member/spc/" +
          window.version +
          "/sendEmailVerifyCode2?type=email_update&expiredTime=5&email=" +
          this.form.email + "&imageToken=" + this.imageToken + "&imageCode=" + this.form.imageCode;
      } else {
        url =
          "/member/spc/" +
          window.version +
          "/sendMobileVerifyCode2?type=mobile_update&expiredTime=5&mobileno=" +
          this.form.phone + "&imageToken=" + this.imageToken + "&imageCode=" + this.form.imageCode;
      }
      if (!this.zcYzm) {
        return false;
      }
      // this.zcYzm = false;
      Get(url).then((res) => {
        if (res.status === 0) {
          this.loding = false;
          this.timeDownSta = true;
          this.registerSta = true;
          this.timeDowns = 60;
          this.getOneCode = false; // 第一次获取验证码
          if (this.timeDowns > 0) {
            let time = setInterval(() => {
              this.timeDowns--;
              if (this.timeDowns == 0) {
                this.timeDownSta = false;
                clearInterval(time);
              }
              if (this.timeDowns < 1) {
                this.zcYzm = true;
              }
            }, 1000);
          }
        } else {
          this.loding = false;
          this.$message.error(res.message);
        }
      });
    },
    toRegister(e) {
      // let sta = this.getImageCodeTrue();
      // setTimeout(() => {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
      });
      // 手机最后验证
      if (
        !this.emailState &&
        this.registerSta &&
        // this.imageCodeSta &&
        this.form.verifyCode &&
        this.form.password == this.form.confirmPassword &&
        this.form.password != ""
      ) {
        this.goNext();
      }
      // 邮箱最后验证
      else if (
        this.emailState &&
        this.regEmailSta &&
        // this.imageCodeSta &&
        this.form.verifyCode &&
        this.form.password == this.form.confirmPassword &&
        this.form.password != ""
      ) {
        this.goNext();
      } else {
        // console.log("未通过");
      }
      // }, 1000);
    },
    // 注册最后
    goNext() {
      let data = {
        ...this.form,
        imageToken: this.imageToken,
        appId: window.appId,
        channel: "0",
      };
      let url = "";
      // 手机
      if (!this.emailState) {
        url = "/member/spc/" + window.version + "/baas/member/registerByPhone";
      }
      // 邮箱
      else {
        url = "/member/spc/" + window.version + "/baas/member/registerByEmail";
      }
      delete data.confirmPassword;
      axios({
        method: "post",
        url: url,
        headers: {
          contentType: "application/json",
          authToken: window.sessionStorage.getItem("token"),
          token: window.sessionStorage.getItem("userToken")
        },
        data: data,
      }).then((res) => {
        if (res.data.status === 0) {
          // 注册成功
          this.registerState_true = true;
          this.loginState = false;
          this.form1 = {};
          this.form = {};
          this.form2 = {};
          this.loginState = false;
          this.registerState = false;
        } else {
          this.refisterTit = res.data.message;
        }
      });
      this.getImagerCode();
    },
    getUserIP(onNewIP) {
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;

      let pc = new MyPeerConnection({
        iceServers: [],
      });
      let noop = () => {};
      let localIPs = {};
      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      };
      pc.createDataChannel("");
      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) return;

            line.match(ipRegex).forEach(iterateIP);
          });
          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {});
      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        )
          return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    // 登录模块  ***
    // 去注册
    goRegister() {
      this.loginState = false;
      this.retrieveState = false;
      this.registerState = true;
      this.form = {};
      this.form1 = {};
      this.form2 = {};
      this.$refs["form1"].resetFields();
      this.$refs["form2"].resetFields();
      this.getImagerCode();

      this.zcYzm = true;
    },
    // 登录接口
    toLogin(a) {
      let params = {
        userName: !a ? this.$getRsaCode(this.form.userName) : "",
        password: !a ? this.$getRsaCode(this.form.password) : "",
        imageCode: this.form.imageCode,
        imageToken: this.imageToken,
        appId: "", //
        source: "2", // 1：APP 2：网站
        channel: "0", // 登录平台
        type: 1, // 1:用户名+密码 2：手机号+验证码
        ip: this.ip,
      };

      if (!a) {
        this.$refs["form1"].validate((valid) => {
          if (!valid) {
            return false;
          }
        });
      }

      // this.getImageCodeTrue();

      if (!a) {
        if (
          !this.form.userName ||
          !this.form.password ||
          !this.form.imageCode
        ) {
          return false;
        }
      }
      if (a) {
        params.userName = a.userName;
        params.password = a.password;
      }

      Post("/member/spc/" + window.version + "/login", params).then((res) => {
        if (res.status === 0) {
          this.$router.push("/personal?nowNav=basicInfo");
          window.localStorage.setItem("memberId", res.data);
          let id = window.localStorage.getItem("memberId");
          this.$store.commit("updateState", {
            key: "memberId",
            value: id,
          });
          if (id) {
            Post(
              "/member/spc/v1/allMemberInfo/getMemberDetail.do?userId=" +
                res.data
            ).then((res) => {
              let data = res.data.content[0];
              localStorage.setItem(
                "loginName",
                data.bassMember.nickName || data.bassMember.loginName
              );
              // 自动登录
              if (this.automaticLogin) {
                let loginData = {
                  user: params.userName,
                  pass: params.password,
                };
                window.localStorage.setItem(
                  "AutoContent",
                  JSON.stringify(loginData)
                );
              }
              if (data.bassMember != null) {
                this.$store.commit("updateState", {
                  key: "bassMember",
                  value: { ...data.bassMember },
                });
              }
              let mobile = data.bassMember.mobile;
              localStorage.setItem("mobile", mobile);
              if (data.bassMember != null) {
                this.$store.commit("updateState", {
                  key: "memberInfo",
                  value: { ...data.memberInfo },
                });
              }
              if (data.memberVocationInfos) {
                this.$store.commit("updateState", {
                  key: "memberVocationInfos",
                  value: data.memberVocationInfos[0].department,
                });
              }
              if (data.expertLabel != null) {
                this.$store.commit("updateState", {
                  key: "zjList",
                  value:
                    data.expertLabel != "" ? JSON.parse(data.expertLabel) : [],
                });
              }
            });
          }
          // JSON.stringify({ userName: this.form.userName, id: res.data })
        } else {
          this.getImagerCode();
          this.Tips = res.message;
          return;
        }
      });
    },

    // 找回密码页面
    // 打开找回
    retrieve() {
      this.loginState = false;
      this.registerState = false;
      this.retrieveState = true;
      this.retrieve_phone = true;
      this.form = {};
      this.$refs["form1"].resetFields();
      this.$refs["form2"].resetFields();
      this.getImagerCode();
    },
    // 找回密码 最后一步 立即找回
    getPassWord() {
      if (this.form.confirmPassword != this.form.password) {
        return;
      }
      // this.$refs["form2"].validate((valid) => {
      //   if (!valid) {
      //     return false;
      //   }
      // });

      // if (
      //   !this.form.phone ||
      //   !this.form.password ||
      //   !this.form.confirmPassword
      // ) {
      //   return false;
      // }
      let data = {
        ...this.form,
        imageToken: this.imageToken,
        appId: window.appId,
        channel: "0",
        expiredTime: 5,
      };
      let url = "";
      // 手机
      // spc/v1/password/retrievePassByEmail
      if (this.retrieve_phone) {
        url = "/member/spc/" + window.version + "/password/retrievePassByPhone";
      }
      // 邮箱
      else {
        url = "/member/spc/" + window.version + "/password/retrievePassByEmail";
      }
      delete data.confirmPassword;
      axios({
        method: "post",
        url: url,
        headers: {
          contentType: "application/json",
          authToken: window.sessionStorage.getItem("token"),
          token: window.sessionStorage.getItem("userToken")
        },
        data: data,
      }).then((res) => {
        if (res.data.status === 0) {
          // this.loginState = true;
          this.retrieveState = false;
          this.form = {};
          this.retrieveState_true = true;
          // this.getImagerCode();
        } else {
          if (res.data.message.indexOf("新密码必须包含") > -1) {
            this.getPasstit = this.$getText("retrievePassByPhone_info_one");
          } else if (res.data.message.indexOf("手机号不存在") > -1) {
            this.getPasstit = this.$getText("retrievePassByPhone_info_two");
          } else if (res.data.message.indexOf("邮箱不存在") > -1) {
            this.getPasstit = this.$getText("retrievePassByEmail_info_one");
          } else if (res.data.message.indexOf("图片验证码已过期") > -1) {
            this.getPasstit = this.$getText("registerByPhone_info_four");
          } else if (res.data.message.indexOf("验证码已过期") > -1) {
            this.getPasstit = this.$getText("registerByPhone_info_one");
          } else if (res.data.message.indexOf("图片验证码不正确") > -1) {
            this.getPasstit = this.$getText("registerByPhone_info_five");
          } else if (res.data.message.indexOf("验证码不一致") > -1) {
            this.getPasstit = this.$getText("registerByPhone_info_two");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.phoneOREmail /deep/ .el-form-item__content {
  width: 186px;
}
.register-switch-button {
  height: 30px;
  position: absolute;
  top: 40px;
  left: 950px;
}
.spanTip {
  color: #999;
  font-size: 14px;
  width: 96%;
  height: 24px;
  line-height: 24px;
  word-break: normal;
  margin-left: 4px;
}
.marginBottom16 {
  margin-bottom: 16px;
}
.flex {
  display: flex;
}
.Password-text {
  width: 100%;
}

.contact_txt_span {
  font-size: 13px;
  color: #68767f;
  margin-bottom: 10px;
  float: left;
  margin-right: 20px;
  overflow: hidden;
  min-width: 138px;
}
.team_title {
  padding-left: 13px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  background: url("../../assets/img/sx.png") no-repeat left center;
  height: 16px;
  line-height: 16px;
  margin-bottom: 23px;
}
.NEW-loginPage {
  min-width: 320px;

  .register {
    width: 970px;
    min-height: 655px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 30px #e0e7f2;
    -moz-box-shadow: 0 10px 30px #e0e7f2;
    -webkit-box-shadow: 0 10px 30px #e0e7f2;
    padding: 60px;
    margin-top: 80px;
    position: relative;
    .register-left {
      width: 400px;
      position: absolute;
      .login_information {
        .image {
          cursor: pointer;
          margin-bottom: 112px;
        }
        .contact_txt {
          font-size: 14px;
          color: #333;
          margin-bottom: 5px;
          font-weight: normal;
          background: url("../../assets/img/title_bg.svg") 4px center no-repeat;
          padding-left: 27px;
          width: 357px;
          overflow: hidden;
        }
        .contact_phone {
          font-size: 13px;
          color: #666;
          margin-bottom: 9px;
          transform: scale(0.78);
          margin-left: -4px;
          padding-left: 32px;
          background: url("../../assets/img/new-Login_icon1.svg") left center
            no-repeat;
        }
        .contact_email {
          font-size: 13px;
          color: #666;
          margin-bottom: 9px;
          padding-left: 30px;
          transform: scale(0.75);
          background: url("../../assets/img/new-Login_icon2.svg") left center
            no-repeat;
        }
        .main_other {
          width: 320px;
          margin-top: 40px;
          position: relative;
          top: -9px;
          left: 80px;
          .header {
            width: 320px;
            font-size: 14px;
            color: #666;
            background: url("../../assets/img/main_other_bg.jpg") center center
              no-repeat;
            text-align: center;
            font-weight: normal;
          }
          .login-icon {
            margin-left: 30px;
            span {
              width: 40px;
              height: 40px;
              float: left;
              margin-left: 33px;
              margin-top: 24px;
              display: block;
              cursor: pointer;
              background-size: 40px !important;
              // border: 1px solid red;
            }
            .qq {
              background: url("../../assets/img/new-Login_Log-icon1.jpg")
                no-repeat;
            }
            .qq:hover {
              background: url("../../assets/img/new-Login_Log-icon1-2.jpg")
                no-repeat;
            }
            .weixin {
              background: url("../../assets/img/new-Login_Log-icon2.jpg")
                no-repeat;
            }
            .weixin:hover {
              background: url("../../assets/img/new-Login_Log-icon2-2.jpg")
                no-repeat;
            }
            .weibo {
              background: url("../../assets/img/new-Login_Log-icon3.jpg")
                no-repeat;
            }
            .weibo:hover {
              background: url("../../assets/img/new-Login_Log-icon3-2.jpg")
                no-repeat;
            }
          }
        }
      }
    }
    .register-form {
      // width: 50%;
      // margin-left: 448px;
      float: right;
      width: 320px;
      height: auto;
      // overflow: hidden;
      /deep/ .el-input__inner {
        height: 42px;
        line-height: 42px;
        border-radius: 0px;
        border: none;
        border-bottom: 1px solid #dddddd;
        padding-left: 0px;
      }
      /deep/ .el-input {
        max-width: 320px;
        font-size: 15px;
      }
      /deep/ .el-form-item__label:before {
        content: "";
        color: white;
        margin-right: 0px;
      }
      /deep/ .el-form-item__label {
        padding: 0;
        height: 100%;
        min-height: 20px;
        line-height: 20px;
        color: #333;
      }
      /deep/ .el-form-item {
        margin-bottom: 22px;
      }
      ::-webkit-input-placeholder {
        font-family: "Microsoft Yahei";
        font-size: 14px;
      }

      .login-tips-text {
        margin-top: 12px;
        color: red;
        font-size: 12px;
        line-height: 10px;
        font-family: "Microsoft Yahei";
      }
      .imgInput {
        // border: 1px solid red;
        width: 209px;
        float: left;
      }
      .imgCode {
        float: left;
        cursor: pointer;
        height: 42px;
        overflow: hidden;
        margin-left: 42px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .codeInput {
        width: 186px;
      }
      .telCode {
        float: left;
        text-align: center;
        cursor: pointer;
        width: 120px;
        height: 42px;
        line-height: 42px;
        border-radius: 4px;
        font-size: 14px;
        border: none;
        position: absolute;
        left: 201px;
        top: -5px;
        background-color: #cfd5e1;
        color: #fff;
      }
      .grayCode {
        background: #cfd5e1;
      }
    }
    .login-setting {
      p {
        font-size: 13px;
      }
      .login-ForgetPass {
        width: 316px;
        display: flex;
        justify-content: space-between;
      }
      .goRegister {
        width: 318px;
        text-align: end;
        line-height: 14px;
      }
    }
    .registerBtn {
      width: 320px;
      height: 42px;
      // line-height: 42px;
      font-size: 16px;
      color: #fff;
      background: #d63630;
      border-radius: 4px;
      // cursor: pointer;
      text-align: center;
      // cursor: default;
      margin-top: 27px;
      user-select: none;
      border: none;
    }
    .registerBtn:hover {
      background: rgb(219, 78, 73);
    }

    .registerBtn1 {
      width: 320px;
      height: 42px;
      // line-height: 42px;
      font-size: 16px;
      color: #fff;
      background: #d63630;
      border-radius: 4px;
      // cursor: pointer;
      text-align: center;
      // cursor: default;
      margin-top: 27px;
      user-select: none;
    }
    .registerBtn1:hover {
      background: rgb(219, 78, 73);
    }

    .login-userInst {
      width: 242px;
      margin-left: 48px !important;
      margin-top: 10px;
    }
    .ForgetPass:hover {
      color: #d63630;
      cursor: pointer;
    }
    .getPass {
      user-select: none;
      width: 320px;
      text-align: end;
      color: #8aa9c1;
      font-size: 13px;
      margin-top: 12px;
    }
    .djBtn {
      color: #8aa9c1;
      cursor: pointer;
    }
    .userInstructions {
      font-size: 12px;
      margin-left: 23px;
      top: 10px;
      position: relative;
      .checked {
        position: absolute;
        left: -23px;
      }

      .qiehuan {
        text-indent: 15px;
        .djGrayBtn {
          cursor: pointer;
          color: #999;
          font-size: 13px;
          text-decoration: underline;
        }
        .djGrayBtn:hover {
          color: #d63630;
        }
      }

      .noUser {
        font-size: 14px;
        text-indent: 46px;
      }
      .goRegister {
        font-size: 13px;
      }
    }
  }
  .headers-getPass {
    padding-left: 13px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    height: 16px;
    line-height: 16px;
    margin-bottom: 25px;
    position: relative;
    margin-left: -8px;
    .divF {
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #d63630;
      position: relative;
      top: 2px;
      left: -5px;
    }
  }
  .register-bottom {
    margin-top: 10px;
    width: 100%;
    height: 74px;
    p {
      font-size: 12px;
      margin: 0;
      padding: 0;
      font-family: "Microsoft Yahei";
      color: #8aa9c1;
      span {
        text-align: center;
        // line-height: 74px;
      }
      .spanColor {
        padding: 0 8px;
        color: #ff9900;
      }
    }
    .h10 {
    }
    width: 650px;
    margin: 0 auto;
    text-align: center;
    color: #333333;
    // line-height: 74px;
    padding: 0 0 0 38px;
    background: url("../../assets/img/new-Login_icon-footer1.png") left center
      no-repeat;
    background-size: 24px;
  }
  .retrieve_true {
    .retrieve_true_title {
      width: 320px;
      display: grid;
      margin-top: 35px;
      .chinese {
        width: 320px;
        margin: 10px 0 10px 0;
        p {
          text-align: center;
          line-height: 30px;
          font-size: 14px;
        }
        color: #333;
      }
      .English {
        width: 320px;
        background: #ecf9fc;
        padding: 16px 64px;
        color: #999;
        font-size: 13px;
        line-height: 24px;
        margin-bottom: 20px;
        text-align: center;
      }
    }
  }
  .register-switch {
    cursor: pointer;
    display: inline-block;
    position: absolute;
    right: 20px;
    width: 60px;
    height: 30px;
    background: #eeeeee;
    border-radius: 63px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    .switch-btn {
      color: #fff;
    }
    .switch-on {
      // position: relative;
      z-index: 1;
      background: #d63630;
      width: 24px;
      height: 24px;
      border-radius: 58px;
      top: 3px;
      left: 3px;
      -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      -webkit-transform: translateX(0px);
      transform: translateX(0px);
    }
    .switch-off {
      left: 33px;
    }
    li:first-child {
      left: 8px;
    }
    li:last-child {
      right: 5px;
    }
    li {
      position: absolute;
      line-height: 30px;
      font-size: 13px;
      z-index: 2;
      -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      color: #999;
      display: inline-block;
    }
  }
  .form >>> .el-form-item__label {
    font-size: 14px;
    color: #333 !important;
    font-weight: normal;
  }
  .Password >>> .el-form-item__label {
    height: 100% !important;
  }
}
.online {
  position: relative;
  top: 10px;
  color: #52b8cc;
  text-align: center;
  width: 320px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  img {
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 6px;
  }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .online {
    position: relative;
    top: 10px;
    color: #52b8cc;
    text-align: center;
    width: 100% !important;
    display: flex;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    img {
      width: 18px;
      height: 18px;
      position: relative;
      top: 3px;
      margin-right: 6px;
    }
  }
  .phoneOREmail /deep/ .el-form-item__content {
    width: 100%;
  }
  .chinese {
    width: 100% !important;
  }
  .retrieve_true_title {
    width: 100% !important;
  }
  .NEW-loginPage .register .registerBtn1 {
    width: 60% !important;
    margin: 27px auto;
  }
  .imgCode {
    margin-left: 0px !important;
  }
  .register {
    width: auto !important;
    margin: 20px !important;
    padding: 30px !important;
    border-radius: 4px !important;
    position: relative !important;
  }
  .register-left {
    display: none;
  }
  .register-form {
    float: none !important;
    width: 100% !important;
    margin-top: 40px;
  }

  .register-switch-button {
    height: 30px;
    position: absolute;
    top: 4.5% !important;
    left: 96.5% !important;
  }
  .NEW-loginPage >>> .el-input {
    width: 100% !important;
    max-width: none !important;
  }
  .telCode {
    right: 0px !important;
    left: auto !important;
    // right: 10%;
  }
  .Password-text {
    width: 100%;
  }
  .headers-getPass {
    margin-bottom: 34px !important;
  }
  .registerBtn {
    width: 100% !important;
  }
  .getPass {
    width: 100% !important;
  }
  .register-bottom {
    display: none !important;
  }
  .NEW-loginPage .Password >>> .el-form-item__label {
    height: auto !important;
  }
  .NEW-loginPage .form >>> .el-form-item__label {
    color: #333;
    font-size: 16px;
    font-weight: normal;
  }
  .NEW-loginPage .register .register-form >>> .el-input__inner {
    font-size: 14px;
    color: #333;
  }
  .NEW-loginPage >>> input::-webkit-input-placeholder {
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-moz-input-placeholder {
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-ms-input-placeholder {
    color: rgba(117, 117, 117, 1);
  }
  .register-bottom {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .online {
    position: relative;
    top: 10px;
    color: #52b8cc;
    text-align: center;
    width: 100% !important;
    display: flex;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    img {
      width: 18px;
      height: 18px;
      position: relative;
      top: 3px;
      margin-right: 6px;
    }
  }
  .phoneOREmail /deep/ .el-form-item__content {
    width: 100%;
  }
  .chinese {
    width: 100% !important;
  }
  .retrieve_true_title {
    width: 100% !important;
  }
  .imgCode {
    margin-left: 0px !important;
  }
  .register {
    width: auto !important;
    margin: 20px !important;
    padding: 30px !important;
    border-radius: 4px !important;
    position: relative !important;
  }
  .register-left {
    display: none;
  }
  .register-form {
    float: none !important;
    width: 100% !important;
    margin-top: 40px;
  }

  .register-switch-button {
    height: 30px;
    position: absolute;
    top: 4.5% !important;
    left: auto !important;
    right: 0px !important;
  }
  .NEW-loginPage >>> .el-input {
    width: 100% !important;
    max-width: none !important;
  }
  .telCode {
    right: 0px !important;
    left: auto !important;
    width: auto !important;
    padding: 0 10px 0 10px !important;
  }
  .Password-text {
    width: 100%;
  }
  .headers-getPass {
    margin-bottom: 34px !important;
  }
  .registerBtn {
    width: 100% !important;
  }
  .getPass {
    width: 100% !important;
  }
  .register-bottom {
    display: none !important;
  }
  .NEW-loginPage .Password >>> .el-form-item__label {
    height: auto !important;
  }
  .NEW-loginPage .form >>> .el-form-item__label {
    color: #333;
    font-size: 16px;
    font-weight: normal;
  }
  .NEW-loginPage .register .register-form >>> .el-input__inner {
    font-size: 12px !important;
    color: #333;
  }
  .NEW-loginPage >>> input::-webkit-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-moz-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-ms-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .register-bottom {
    display: none;
  }
}
@media screen and (min-width: 421px) and (max-width: 767px) {
  .online {
    position: relative;
    top: 10px;
    color: #52b8cc;
    text-align: center;
    width: 100% !important;
    display: flex;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    img {
      width: 18px;
      height: 18px;
      position: relative;
      top: 3px;
      margin-right: 6px;
    }
  }
  .phoneOREmail /deep/ .el-form-item__content {
    width: 100%;
  }
  .chinese {
    width: 100% !important;
  }
  .retrieve_true_title {
    width: 100% !important;
  }
  .NEW-loginPage .register .registerBtn1 {
    width: 60% !important;
    margin: 27px auto;
  }
  .imgCode {
    margin-left: 0px !important;
  }
  .register {
    width: auto !important;
    margin: 20px !important;
    padding: 30px !important;
    border-radius: 4px !important;
    position: relative !important;
  }
  .register-left {
    display: none;
  }
  .register-form {
    float: none !important;
    width: 100% !important;
    margin-top: 40px;
  }

  .register-switch-button {
    height: 30px;
    position: absolute;
    top: 4.5% !important;
    left: auto !important;
    right: 0px !important;
  }
  .NEW-loginPage >>> .el-input {
    width: 100% !important;
    max-width: none !important;
  }
  .telCode {
    right: 0px !important;
    left: auto !important;
    width: auto !important;
    padding: 0 10px 0 10px !important;
  }
  .Password-text {
    width: 100%;
  }
  .headers-getPass {
    margin-bottom: 34px !important;
  }
  .registerBtn {
    width: 100% !important;
  }
  .getPass {
    width: 100% !important;
  }
  .register-bottom {
    display: none !important;
  }
  .NEW-loginPage .Password >>> .el-form-item__label {
    height: auto !important;
  }
  .NEW-loginPage .form >>> .el-form-item__label {
    color: #333;
    font-size: 16px;
    font-weight: normal;
  }
  .NEW-loginPage .register .register-form >>> .el-input__inner {
    font-size: 12px !important;
    color: #333;
  }
  .NEW-loginPage >>> input::-webkit-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-moz-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .NEW-loginPage >>> input::-ms-input-placeholder {
    font-size: 12px !important;
    color: rgba(117, 117, 117, 1);
  }
  .register-bottom {
    display: none;
  }
}
.NEW-loginPage /deep/ input:-internal-autofill-previewed,
.NEW-loginPage /deep/ input:-internal-autofill-selected {
  -webkit-text-fill-color: #606266 !important;
  transition: background-color 5000s ease-in-out 0s !important;
  caret-color: #606266;
}
.register-form /deep/ .el-form-item__error {
  word-break: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/login/getPass.vue